import axios from "axios";
var CryptoJS = require("crypto-js");

class DataApi {
    constructor() {
        this.URL = "https://" + process.env.VUE_APP_MAIN_URL + "/api/web-logs";
        this.cryptageKey = "2687da56-4181-48a6-bec4-c526727423f8"
    }

    encrypt(datas) {
        return { data: CryptoJS.AES.encrypt(JSON.stringify(datas), this.cryptageKey).toString() }
    }

    decrypt(data) {
        var bytes = CryptoJS.AES.decrypt(data, this.cryptageKey);
        var originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return originalData
    }

    // Récupère les logs, éventuellement filtrés côté serveur.
    get_logs(filters, callback) {
        let datas = filters || {}
        axios.post(this.URL + '/v1/get_logs', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Récupère l'intégralité des logs (sans filtre).
    get_logs_all(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_logs_all', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Détail d'un log par sa clé primaire.
    get_log_by_id(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/get_log_by_id', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Statistiques agrégées (compteurs par niveau/statut, durée moyenne…).
    get_logs_stats(filters, callback) {
        let datas = filters || {}
        axios.post(this.URL + '/v1/get_logs_stats', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Liste des clients / sites distincts (pour le filtre déroulant).
    get_logs_clients(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_logs_clients', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Supprime un log par sa clé primaire.
    delete_log(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/delete_log', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }

    // Purge les logs antérieurs à une date donnée.
    purge_logs(before, callback) {
        let datas = { before }
        axios.post(this.URL + '/v1/purge_logs', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        }).catch(() => {
            callback({ code: -1 });
        });
    }
}

export default new DataApi()
